module.exports = __webpack_public_path__ + "img/pantalla-1-3-1.e75f9476.png";